import { Box, HStack, Text, TextArea, VStack, useTheme } from "native-base";
import React, { useState } from "react";
import StarRating from "react-native-star-rating-widget";

import Badge from "@/components/atoms/Badge";
import FormButton from "@/components/atoms/FormButton";

import { OrdeEvaluationComponentProps, StoreEvaluationData } from "../types";

const services = ["Tempo de resposta", "Atendimento", "Embalagem", "Trocas", "Transporte"] as const;

type EvaluationService = typeof services[number];

const StoreEvaluationStep = ({
  onSubmit,
  onCancel,
}: OrdeEvaluationComponentProps<StoreEvaluationData>) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [selectedServices, setSelectedServices] = useState<EvaluationService[]>([]);

  const { colors } = useTheme();

  const onSelecteService = (service: EvaluationService) => {
    if (selectedServices.includes(service)) {
      setSelectedServices((prev) => prev.filter((s) => s !== service));
    } else {
      setSelectedServices((prev) => [...prev, service]);
    }
  };

  return (
    <VStack>
      <VStack my="2" space={2} alignItems="center">
        <Text fontSize="lg" color="primary.600">
          Como foi sua experiência?
        </Text>
        <Text color="gray.400" textAlign="center">
          Avalie, com base na quantidade de estrelas, a sua satisfação com a loja
        </Text>
      </VStack>
      <Box my="4" alignItems="center">
        <StarRating
          rating={rating}
          color={colors.primary["600"]}
          starSize={46}
          enableHalfStar={false}
          onChange={setRating}
        />
      </Box>
      {!!rating && (
        <VStack>
          <Text color="gray.400" my="2" alignSelf="center">
            Em quais pontos você acha que podemos melhorar?
          </Text>
          <HStack my="4" flexWrap="wrap">
            {services.map((service) => (
              <Box key={service} p="1">
                <Badge
                  label={service}
                  active={selectedServices.includes(service)}
                  onSelect={() => onSelecteService(service)}
                />
              </Box>
            ))}
          </HStack>
        </VStack>
      )}
      <TextArea
        value={comment}
        variant="underlined"
        maxLength={300}
        numberOfLines={4}
        onChangeText={(text) => setComment(text)}
        placeholder="Comentários"
        mb="5"
        fontSize="md"
        autoCompleteType
      />
      <HStack my="4" justifyContent="space-between">
        <FormButton
          width="40%"
          colorScheme="white"
          textColor="primary.700"
          shadow="2"
          onPress={() => onCancel()}>
          Cancelar
        </FormButton>
        <FormButton
          isDisabled={!rating}
          width="40%"
          onPress={() =>
            onSubmit({
              comment,
              rate: rating,
              services: selectedServices,
            })
          }>
          Próximo
        </FormButton>
      </HStack>
    </VStack>
  );
};

export default StoreEvaluationStep;
